import { Controller } from "@hotwired/stimulus"

// Full-size view of one picture, over the page.
//
// The review page fits the viewport, which means both the reference photos and
// the renders are shown small — fine for picking one, useless for judging a
// collar or a print. Clicking either opens it here at full size.
//
// The source is taken from `data-zoom-src` rather than from the thumbnail's own
// `src`: a Drive reference is served as a 400px thumbnail and blowing that up
// shows nothing new, so the trigger carries a high-resolution URL of its own.
export default class extends Controller {
  static targets = ["overlay", "image", "caption"]

  connect() {
    this.onKey = this.onKey.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
    document.body.style.overflow = ""
  }

  open(event) {
    const trigger = event.currentTarget
    const src = trigger.dataset.zoomSrc || trigger.getAttribute("src")
    if (!src) return

    this.imageTarget.src = src
    this.imageTarget.alt = trigger.dataset.zoomLabel || ""
    this.captionTarget.textContent = trigger.dataset.zoomLabel || ""
    this.overlayTarget.classList.add("is-open")
    // The page behind must not scroll while the overlay is up.
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.onKey)
  }

  close() {
    this.overlayTarget.classList.remove("is-open")
    // Dropped so a reopened overlay never flashes the previous picture.
    this.imageTarget.removeAttribute("src")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.onKey)
  }

  // Clicks on the picture itself must not close it; clicks on the backdrop must.
  backdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  onKey(event) {
    if (event.key === "Escape") this.close()
  }
}
